<template>
  <div class="home">
    <div class="service-tip">
      最新服务<img style="height: 30px;margin-left: 10px;" src="../../assets/icon/new.png">
    </div>

    <el-row>
      <el-col :span="6" v-for="(service,index) in this.latestServices" :key="index">
        <div class="service" :style="'background: url(' + require('@/assets/img/service_bg_'+(index)%4+'.png') + ') center center;'">
          <div class="title">{{service.name}}</div>
          <!-- <div class="intro">{{service.intro}}</div> -->
          <div class="btn" @click="goToService(service)">马上办理</div>
        </div>
      </el-col>
    </el-row>

    <el-divider></el-divider>
    <div class="service-tip">
      热门服务<img style="height: 30px;margin-left: 10px;" src="../../assets/icon/hot.png">
    </div>

    <el-row>
      <el-col :span="6" v-for="(service,index) in this.hotServices" :key="index">
        <div class="service" :style="'background: url(' + require('@/assets/img/service_bg_'+(index)%4+'.png') + ') center center;'">
          <div class="title">{{service.name}}</div>
          <!-- <div class="intro">{{service.intro}}</div> -->
          <div class="btn" @click="goToService(service)">马上办理</div>
        </div>
      </el-col>
    </el-row>

    <div style="height:50px;"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        latestServices: [],
        hotServices: []
      }
    },
    mounted() {
      this.loadLatestServices()
      this.loadHotServices()
    },
    components: {},
    methods: {
      loadLatestServices() {
        this.$http.latestServices().then(res => {
          if (res.code === 0) {
            this.latestServices = res.data.data
          }
        })
      },
      loadHotServices() {
        this.$http.hotServices().then(res => {
          if (res.code === 0) {
            this.hotServices = res.data.data
          }
        })
      },
      goToService(service) {
        this.$router.push({
          name: 'serverDetail',
          params: {
            serviceId: service.id
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .home {
    width: 100%;
    margin: 0 auto;
  }

  .service:hover {
    transform: translate(0, -15px);
    transition: transform .5s ease-in-out;
    box-shadow: 0 10px 20px 1px rgba(49, 49, 49, 0.2);
    border: 1px solid #FFFFFF;
    background-image: none !important;
    background-color: #617596 !important;

    .btn {
      opacity: 1;
    }

    .title {
      transition: font-size .5s ease-in-out;
      color: #FFFFFF;
      font-size: 24px;
      padding: 0 !important;
    }

    .intro {
      color: #FFFFFF;
      font-size: 17px;
    }
  }

  .service {
    transition: transform .5s ease-in-out;
    background: #fff;
    // width: 350px;
    // height: 150px;
    width: 18vw;
    height: 12.5vh;
    margin-top: 30px;
    margin-bottom: 30px;
    border: 1px solid #ddd;
    color: #337ab7;
    padding-top: 25px;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 8px;
    position: relative;

    .title {
      font-size: 22px;
      font-weight: 700;
      line-height: 24px;
      padding: 0 !important;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      transition: font-size .5s ease-in-out;
    }

    .intro {
      white-space: normal;
      margin-top: 12px;
      line-height: 20px;
      color: #333;
      font-size: 17px;
      display: block;
    }

    .btn {
      opacity: 0;
      position: absolute;
      right: 20px;
      bottom: 10px;
      width: 98px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: center;
      color: #333;
      border-radius: 20px;
      background-color: #fff;
      transition: all .5s ease-in-out;
      cursor: pointer;
    }
  }

  .service-tip {
    text-align: left;
    padding-left: 5px;
    font-size: 26px;
    color: #333;
    font-weight: 700;
    font-family: '微软雅黑';
  }
</style>



// WEBPACK FOOTER //
// src/views/viewList/Home.vue